import React from "react";
import PropTypes from "prop-types";
import { Password, Label } from "../../../components/Inputs";
import { validatePassword } from "../../../components/Utils";

const PasswordChangeFormContent = (props) => {
  const { className, forwardedRef } = props;
  const [state, setFormState] = React.useState(() => ({
    oldPassword: "",
    newPassword: "",
    newPassword2: "",
    error: {
      newPassword: null,
      newPassword2: null,
      oldPassword: null,
    },
  }));
  // class-style partial merge so former this.setState(patch) call sites stay valid
  const setState = (patch) => setFormState((prev) => ({ ...prev, ...patch }));

  const validate = () => {
    const { error, ...model } = state;
    // check if all values are set
    let isValid = true;
    Object.keys(model).forEach((key) => {
      if (error[key] !== undefined && model[key] === "") {
        error[key] = "";
        isValid = false;
      }
    });
    // new password
    const test = {};
    if (!validatePassword(model.newPassword, test)) {
      error.newPassword = test.error || "ungültiges Passwort";
      isValid = false;
    }
    // new password repeated
    if (model.newPassword !== model.newPassword2) {
      error.newPassword2 = "Beide Passwörter stimmen nicht überein";
      isValid = false;
    }
    setState({ error });
    if (!isValid) {
      return null;
    }
    return model;
  };
  const getModel = () => validate();
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const { oldPassword, newPassword, newPassword2, error } = state;
  return (
    <div className={className}>
      <div className={`${error.oldPassword && "error-group"}`}>
        <Label htmlFor="oldPassword">
          {`Altes Passwort`}
          <span>*</span>
        </Label>
        <Password
          id="oldPassword"
          autoFocus
          className=""
          value={oldPassword}
          onChange={(event) => setState({ oldPassword: event.target.value })}
        />
      </div>
      <div className={`pad-top ${error.newPassword && "error-group"}`}>
        <Label htmlFor="newPassword">
          {`Neues Passwort`}
          <span>*</span>
        </Label>
        <Password
          id="newPassword"
          className=""
          value={newPassword}
          onChange={(event) => setState({ newPassword: event.target.value })}
        />
        {error.newPassword && (
          <div className="pad-sm-top">{error.newPassword}</div>
        )}
      </div>
      <div className={`pad-top ${error.newPassword2 && "error-group"}`}>
        <Label htmlFor="newPassword2">
          {`Neues Passwort wiederholen`}
          <span>*</span>
        </Label>
        <Password
          id="newPassword2"
          className=""
          value={newPassword2}
          onChange={(event) => setState({ newPassword2: event.target.value })}
        />
        {error.newPassword2 && (
          <div className="pad-sm-top">{error.newPassword2}</div>
        )}
      </div>
    </div>
  );
};

PasswordChangeFormContent.propTypes = {
  className: PropTypes.string,
};

export default React.forwardRef((props, ref) => (
  <PasswordChangeFormContent {...props} forwardedRef={ref} />
));
